<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-credit-card fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Moyens de paiement</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation()">
        <i class="bi bi-plus-circle me-1"></i> Nouveau Moyen
      </button>
    </div>

    <!-- Filtres et recherche -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input type="text" v-model="searchQuery" placeholder="Nom..." class="form-control form-control-clinique">
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement des moyens de paiement...</p>
    </div>

    <!-- Tableau moderne -->
    <div v-else class="card shadow-sm rounded card-clinique">
      <div class="table-responsive overflow-auto">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Activé</th>
              <th>Date création</th>
              <th>Date mise à jour</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(mode, index) in filteredModes" :key="mode.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ mode.nom }}</td>
              <td>{{ mode.isEnabled ? 'Oui' : 'Non' }}</td>
              <td>{{ formatDate(mode.createdAt) }}</td>
              <td>{{ formatDate(mode.updatedAt) }}</td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="modifier(mode.id)">Modifier</a></li>
                    <li><a class="dropdown-item text-danger" @click="supprimer(mode.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="modesPaiement.length === 0">
              <td colspan="6" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern flex-wrap mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'mp.createdAt',
      sortOrder: 'desc',
      modesPaiement: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [2, 4, 6, 10],
      orderByTabs: {
        Nom: 'mp.nom',
        Création: 'mp.createdAt',
        'Mise à jour': 'mp.updatedAt'
      },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' }
    };
  },
  computed: {
    filteredModes() {
      if (!this.searchQuery) return this.modesPaiement;
      const q = this.searchQuery.toLowerCase();
      return this.modesPaiement.filter(mode =>
        mode.nom.toLowerCase().includes(q)
      );
    },
    totalPages() { return Math.ceil(this.totalItems / this.itemsperpage); }
  },
  methods: {
    formatDate(date) { return dayjs(date).format('DD-MM-YYYY HH:mm'); },
    creation() { this.$router.push({ name: 'create_moyen' }); },
    modifier(id) { this.$router.push({ name: 'edit_moyen', params: { id } }); },
    async getModes() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const response = await api.getItems('moyen_paiements', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: this.itemsperpage,
          page: this.currentPage,
          search: this.searchQuery
        });
        const { data, meta } = response.data;
        this.modesPaiement = data;
        this.totalItems = meta?.total_records ?? data.length;
      } catch (error) {
        console.error('Erreur lors de la récupération des moyens de paiement :', error);
      } finally {
        this.isLoading = false;
      }
    },
    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer ce moyen de paiement ?")) return;
      try {
        await api.deleteItem('moyen_paiements', id);
        this.getModes();
      } catch {
        alert("Erreur lors de la suppression.");
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getModes();
      }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getModes(); },
    itemsperpage() { this.currentPage = 1; this.getModes(); },
    orderBy() { this.getModes(); },
    sortOrder() { this.getModes(); }
  },
  created() { this.getModes(); }
};
</script>

<style scoped>
/* Tu peux reprendre le CSS de ton tableau moderne pour patienter, header-clinique, card-clinique */
</style>
